/*
 * Bordeaux 12 - project behaviour
 * ---------------------------------------------------------------------------
 * Deliberately small, same footprint policy as bordeaux12.css: one thing
 * Horizon's theme settings cannot do, scoped to the one section that needs it.
 */

/*
 * Homepage trust bar: the box outline draws itself in - top out from the
 * centre, then both sides down, then the bottom closing in to meet - the
 * first time it scrolls into view. See the matching comment in
 * bordeaux12.css for the CSS side of this (the five-layer background-image
 * technique, and why the resting state without this script is already a
 * complete border).
 *
 * IntersectionObserver rather than a scroll listener: fires once, doesn't
 * need throttling, and every browser this shop supports already has it.
 * Runs once and disconnects - this plays a first-impression moment, not a
 * repeating one, so scrolling past the box and back does not replay it.
 */
(function () {
  var boxes = document.querySelectorAll("[id$='__trust_bar_b12tr1'] .custom-section-content");
  if (!boxes.length) return;

  var reducedMotion = false;
  try {
    reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (error) {
    reducedMotion = false;
  }

  // Reduced motion, or no IntersectionObserver: leave the CSS resting state
  // alone. That resting state is already the complete border, so there is
  // nothing to arm and nothing missing either way.
  if (reducedMotion || !('IntersectionObserver' in window)) return;

  boxes.forEach(function (box) {
    box.classList.add('b12-trust-border--armed');

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.disconnect();
          box.classList.add('b12-trust-border--drawing');
        });
      },
      { threshold: 0.3 }
    );

    observer.observe(box);
  });
})();

/*
 * Homepage video hero: autoplay-blocked fallback and prefers-reduced-motion.
 *
 * This used to also add a pause/play toggle button, for WCAG 2.2's 2.2.2
 * (Pause, Stop, Hide) - Horizon's `hero` section autoplays a looping video
 * with no way to stop it (`controls: false` is hardcoded in the section's
 * video_tag call), and a silent indefinitely-looping video with no control
 * is exactly what that criterion covers. Matt approved removing it anyway
 * (2026-09-24, see DECISIONS.md on project-docs) - logged as a known,
 * accepted compliance gap rather than silently dropped.
 *
 * What's left: if autoplay is blocked (e.g. iOS Low Power Mode, which
 * disables background video autoplay outright), a paused <video> with
 * controls="false" still gets WebKit's own native play affordance drawn
 * over it. Since there's no button anymore to start it manually, the best
 * remaining option is a static poster <img> in its place, so there's at
 * least a clean still image rather than a paused video with browser chrome
 * on it. Same fallback for prefers-reduced-motion.
 */
(function () {
  var sections = document.querySelectorAll("[id$='__hero_video_walk1']");
  if (!sections.length) return;

  var reducedMotion = false;
  try {
    reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (error) {
    reducedMotion = false;
  }

  sections.forEach(function (section) {
    var video = section.querySelector('video.hero__media');
    if (!video) return;

    var wrapper = video.closest('.hero__media-wrapper') || section;
    var posterSrc = video.getAttribute('poster');

    function showPosterFallback() {
      video.classList.add('b12-hero-video--autoplay-blocked');
      if (!posterSrc) return;
      var posterImage = document.createElement('img');
      posterImage.src = posterSrc;
      posterImage.alt = '';
      posterImage.className = video.className + ' b12-hero-video-poster';
      wrapper.insertBefore(posterImage, video);
    }

    if (reducedMotion) {
      video.pause();
      showPosterFallback();
      return;
    }

    var initialPlay = video.play();
    if (initialPlay && typeof initialPlay.catch === 'function') {
      initialPlay.catch(showPosterFallback);
    }
  });
})();
